import { Component } from 'react';

import { maskedValue, PatternMask } from '../masked';
import { MaskedInputProps } from '../maskedInput/MaskedInput';

import { createNewDatePatternMask } from './helpers';
import { DateMaskInputProps } from './types';

export default (MaskedInput: React.ComponentClass<MaskedInputProps>) => {
    class DateMaskInput extends Component<DateMaskInputProps> {
        private patternMask: PatternMask;
        private dateFormatPattern: string;

        constructor(props: DateMaskInputProps) {
            super(props);
            this.patternMask = createNewDatePatternMask(props);
            this.dateFormatPattern = props.dateFormatPattern;
        }

        render() {
            const { dateValue, dateFormatPattern, ...other } = this.props;

            let maskedDateValue = dateValue;
            if (dateFormatPattern !== this.dateFormatPattern) {
                this.patternMask = createNewDatePatternMask(this.props);
                this.dateFormatPattern = dateFormatPattern;

                const { value: unmaskedDateValue } = maskedValue.unmaskValue(
                    { value: maskedDateValue, selection: { start: 0, end: 0 } },
                    this.patternMask
                );
                ({ value: maskedDateValue } = maskedValue.maskValue(unmaskedDateValue, this.patternMask));
            }

            return <MaskedInput {...other} mask={this.patternMask} value={maskedDateValue} type="tel" />;
        }
    }
    return DateMaskInput;
};
